export default __webpack_public_path__ + "static/media/ic-cultivation-4.9a45ea32.svg";